if (!customElements.get("collection-view")) {
  class CollectionView extends HTMLElement {
    static CURRENT_CLASS = "is-current";
    static CURRENT_SELECTOR = ".is-current";

    constructor() {
      super();
    }

    handleClick(event) {
      const button = event.target.closest("button");
      if (!button) return;

      const section = this.closest(".shopify-section");
      if (!section) return;

      event.preventDefault();
      event.stopPropagation();

      this.querySelector(CollectionView.CURRENT_SELECTOR)?.classList.remove(
        CollectionView.CURRENT_CLASS
      );
      button.classList.add(CollectionView.CURRENT_CLASS);

      const view = button.getAttribute("js-view");
      section.setAttribute("css-view", view);
      localStorage.setItem("collection-view", view);
    }

    handleCache() {
      const view = localStorage.getItem("collection-view");
      if (!view) return;

      const button = this.querySelector(`[js-view="${view}"]`);
      if (!button) return;

      button.click();
    }

    connectedCallback() {
      this.addEventListener("click", this.handleClick.bind(this));

      this.handleCache();
    }
  }

  customElements.define("collection-view", CollectionView);
}
